export default __webpack_public_path__ + "static/media/Pyra_blue.6e98a497.png";